import AppInNewWindow from './AppInNewWindow';
export default AppInNewWindow;
